export const articleMedia: Record<
  string,
  { src: string; icon: 'chip' | 'network' | 'code' }
> = {
  'dextro-cloud-independent-iot-platform': {
    src: '/images/articles/dextro-cloud.webp',
    icon: 'network',
  },
  'connected-products-from-prototype-to-production': {
    src: '/images/articles/prototype.webp',
    icon: 'chip',
  },
  'industrial-iot-gateway-integration': {
    src: '/images/articles/gateway.webp',
    icon: 'network',
  },
  'web-platforms-distributed-operations': {
    src: '/images/articles/operations.webp',
    icon: 'code',
  },
  'building-chave-digital-from-the-board-up': {
    src: '/images/articles/chave-production.webp',
    icon: 'chip',
  },
  'mais-pipoca-popcorn-vending-machine-electronics': {
    src: '/images/articles/mais-pipoca.webp',
    icon: 'chip',
  },
  'embedded-linux-kernel-debugging-loop': {
    src: '/images/portfolio/notebook.webp',
    icon: 'code',
  },
}
